import api from "apis";

export const bulkUploadApi = api.injectEndpoints({
  endpoints: (build) => ({
    bulkUpload: build.mutation({
      query: (body) => ({
        url: "/bulk-upload/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["EmployeeShiftS", "FixedTemplates"],
    }),
    leaveBalanceBulkUpload: build.mutation({
      query: (body) => ({
        url: "/integration-leave-balance-bulk-upload/",
        method: "POST",
        body,
      }),
      invalidatesTags: ["LeaveBalanceLogs"],
    }),
  }),
});

export const { useBulkUploadMutation, useLeaveBalanceBulkUploadMutation } =
  bulkUploadApi;
